import React, { useState, useEffect, useRef } from 'react';
import SignatureCanvas from "react-signature-canvas";
import { useNavigate } from "react-router-dom";

export default function PaymentPage() {
  const [amount, setAmount] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const sigPadRef = useRef(null);
const [signature, setSignature] = useState(null);
const [isSaved, setIsSaved] = useState(false);


const [location, setLocation] = useState(null);
const [loadingLocation, setLoadingLocation] = useState(false);
const [locationError, setLocationError] = useState(null);


const [fullName, setFullName] = useState("");
const [email, setEmail] = useState("");
const [mobile, setMobile] = useState("");
const [address, setAddress] = useState("");




useEffect(() => {
  if (!navigator.geolocation) {
    setLocationError("Geolocation not supported");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude, accuracy } = position.coords;

      setLocation({
        latitude,
        longitude,
        accuracy,
      });

      // 🔥 CALL GOOGLE API HERE
      getAddress(latitude, longitude);
    },
    (error) => {
      setLocationError(error.message);
    },
    {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0,
    }
  );
}, []);




const getLocation = () => {
  if (!navigator.geolocation) {
    setLocationError("Geolocation not supported");
    return;
  }

  setLoadingLocation(true);

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude, accuracy } = position.coords;

      setLocation({
        latitude,
        longitude,
        accuracy, // in meters
      });

      setLoadingLocation(false);
    },
    (error) => {
      setLocationError(error.message);
      setLoadingLocation(false);
    },
    {
      enableHighAccuracy: true, // 🔥 important
      timeout: 15000,
      maximumAge: 0,
    }
  );
};






const clearSignature = () => {
  sigPadRef.current.clear();
  setSignature(null);
  setIsSaved(false);
};

const saveSignature = () => {
  if (!sigPadRef.current.isEmpty()) {
    const data = sigPadRef.current.toDataURL();
    setSignature(data);
     setIsSaved(true);
  }
};






const API_KEY = "AIzaSyAA5mCXU8WrBOym-1rZvzADu4YvZWhAja8"; // 🔥 replace this

const getAddress = async (lat, lng) => {
  try {
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`
    );

    const data = await res.json();

    if (data.results && data.results.length > 0) {
      const result = data.results[0];

      let area = "";
      let city = "";
      let state = "";
      let country = "";
      let pincode = "";

      result.address_components.forEach((comp) => {
        const types = comp.types;

        if (types.includes("sublocality") || types.includes("neighborhood")) {
          area = comp.long_name;
        }
        if (types.includes("locality")) {
          city = comp.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          state = comp.long_name;
        }
        if (types.includes("country")) {
          country = comp.long_name;
        }
        if (types.includes("postal_code")) {
          pincode = comp.long_name;
        }
      });

      const formatted = `${area}, ${city}, ${state}, ${country} - ${pincode}`;

      setAddress(formatted);
    }
  } catch (err) {
    console.error("Geocode Error:", err);
  }
};





const handleSubmit = async () => {
  if (!fullName || !email || !mobile) {
    alert("Fill all details");
    return;
  }

  if (!signature) {
    alert("Signature is required");
    return;
  }


    setLoading(true); // 🔥 START LOADING


  const payload = {
    fullName,
    email,
    mobile,
    amount,
    signatureBase64: signature,
    location: address || "Auto-detected",
    lat: location.latitude,
    lng: location.longitude,
  };

  console.log("Sending Payload:", payload); // DEBUG

  try {
    const res = await fetch(
      "https://demoapi.stockwiseiq.in/api/submitandpay",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    console.log("API Response:", data);

    if (res.ok) {
  navigate("/success", {
    state: {
      fullName,
      email,
      amount,
    },
  });
} else {
      alert(data.message || "❌ Failed");
    }

  } catch (error) {
    console.error("API Error:", error);
    alert("🚨 Server Error");
  }finally{
        setLoading(false); // 🔥 STOP LOADING

  }
};

  // Suggested amounts for quick selection
  const quickAmounts = ['500', '1000', '2500', '5000'];

  return (
    <div className="min-h-screen bg-[#F7F4F2] flex items-center justify-center p-4 md:p-8">
      {/* Main Container */}
      <div className="w-full max-w-5xl bg-white rounded-[30px] shadow-2xl overflow-hidden flex flex-col md:flex-row border border-gray-100">
        
        {/* Left Side: Summary & Branding */}
        <div className="w-full md:w-5/12 bg-black p-8 md:p-12 text-white flex flex-col justify-between">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold mb-2">StockWiseIQ</h2>
            <p className="text-blue-500 text-sm font-medium mb-8 uppercase tracking-widest">Premium Trading Terminal</p>
            
            <div className="space-y-6">
              <div className="bg-white/5 p-6 rounded-2xl border border-white/10">
                <p className="text-gray-400 text-xs uppercase tracking-wider mb-2">Selected Amount</p>
                <div className="text-4xl font-bold">
                  ₹{amount || '0'}
                </div>
              </div>

              <div className="space-y-3">
                <div className="flex items-center gap-3 text-gray-300">
                  <i className="fa fa-check-circle text-green-500"></i>
                  <span className="text-sm">Real-time Market Insights</span>
                </div>
                <div className="flex items-center gap-3 text-gray-300">
                  <i className="fa fa-check-circle text-green-500"></i>
                  <span className="text-sm">Expert Strategy Templates</span>
                </div>
                <div className="flex items-center gap-3 text-gray-300">
                  <i className="fa fa-check-circle text-green-500"></i>
                  <span className="text-sm">24/7 Premium Support</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 md:mt-0 pt-6 border-t border-white/10">
            <p className="text-[10px] text-gray-500 uppercase tracking-widest leading-relaxed">
              Safe & Secure Payments via Encrypted Gateway
            </p>
          </div>
        </div>

        {/* Right Side: Payment Form */}
        <div className="w-full md:w-7/12 p-6 md:p-12">
          <div className="mb-8">
            <h3 className="text-xl font-bold text-gray-900">Payment Details</h3>
            <p className="text-sm text-gray-500">Fill in the information below to proceed</p>
          </div>

          <form className="space-y-6">
            {/* Amount Entry Section */}
            <div className="relative group">
              <label className="text-[10px] font-bold uppercase text-gray-400 ml-1 mb-2 block tracking-wider group-focus-within:text-black transition-colors">
                Enter Amount (INR)
              </label>
              <div className="relative">
                <span className="absolute left-5 top-1/2 -translate-y-1/2 text-2xl font-bold text-gray-400 group-focus-within:text-black">₹</span>
                <input 
                  type="number" 
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="0.00"
                  className="w-full pl-12 pr-4 py-4 text-2xl font-bold bg-gray-50 border-2 border-transparent rounded-2xl focus:bg-white focus:border-black focus:ring-4 focus:ring-black/5 transition-all outline-none placeholder:text-gray-200"
                />
              </div>
              
              {/* Quick Select Buttons */}
              <div className="flex gap-2 mt-3">
                {quickAmounts.map((amt) => (
                  <button
                    key={amt}
                    type="button"
                    onClick={() => setAmount(amt)}
                    className="px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-200 hover:border-black hover:bg-black hover:text-white transition-all"
                  >
                    +₹{amt}
                  </button>
                ))}
              </div>
            </div>

            {/* Personal Details */}
            <div className="grid grid-cols-1 gap-5">
              <div className="relative">
                <label className="text-[10px] font-bold uppercase text-gray-400 ml-1 mb-1 block tracking-wider">Full Name</label>
                <div className="flex items-center">
                  <span className="absolute left-4 text-gray-400"><i className="fa fa-user"></i></span>
                  <input 
                    type="text" 
                     value={fullName}
                     onChange={(e) => setFullName(e.target.value)}
                    placeholder="John Doe"
                    className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl focus:bg-white focus:border-black transition-all outline-none"
                  />
                </div>
              </div>

              <div className="relative">
                <label className="text-[10px] font-bold uppercase text-gray-400 ml-1 mb-1 block tracking-wider">Email Address</label>
                <div className="flex items-center">
                  <span className="absolute left-4 text-gray-400"><i className="fa fa-envelope"></i></span>
                  <input 
                    type="email" 
  value={email}
  onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl focus:bg-white focus:border-black transition-all outline-none"
                  />
                </div>
              </div>

              <div className="relative">
                <label className="text-[10px] font-bold uppercase text-gray-400 ml-1 mb-1 block tracking-wider">Mobile Number</label>
                <div className="flex items-center">
                  <span className="absolute left-4 text-gray-400"><i className="fa fa-phone"></i></span>
                  <input 
                      type="tel"
  value={mobile}
  onChange={(e) => setMobile(e.target.value)}
                    placeholder="+91 00000 00000"
                    className="w-full pl-12 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl focus:bg-white focus:border-black transition-all outline-none"
                  />
                </div>
              </div>
            </div>








            {/* Signature Section */}
<div className="space-y-2">
  <label className="flex items-center justify-between text-[10px] font-bold uppercase text-gray-400 ml-1 tracking-wider">
                <span>E-Signature (Required)</span>
                {isSaved && <span className="text-green-500 font-bold capitalize">✓ Signature Captured</span>}
              </label>

  <div className="border-2 border-dashed border-gray-300 rounded-2xl p-3 bg-gray-50">
    <SignatureCanvas
      penColor="black"
      canvasProps={{
        className: "w-full h-40 rounded-xl bg-white"
      }}
    onEnd={() => setSignature(sigPadRef.current.toDataURL())}
      ref={sigPadRef}
    />
  </div>

  <div className="flex gap-3">
    <button
      type="button"
      onClick={clearSignature}
      className="px-4 py-2 text-xs rounded-lg border border-gray-300 hover:bg-gray-100"
    >
      Clear
    </button>



    

 <button
  type="button"
  onClick={saveSignature}
  className={`px-4 py-2 text-xs rounded-lg ${
    isSaved
      ? "bg-green-600 text-white"
      : "bg-black text-white hover:bg-gray-800"
  }`}
>
  {isSaved ? "Signature Saved" : "Save Signature"}
</button>




  </div>

  {!signature && (
    <p className="text-xs text-red-500">Signature is required</p>
  )}
</div>












            {/* Check Box Verification */}
            <div 
              onClick={() => setIsChecked(!isChecked)}
              className={`flex items-center justify-between p-4 rounded-2xl cursor-pointer transition-all border-2 ${isChecked ? 'border-black bg-gray-50' : 'border-dashed border-gray-200 bg-white hover:border-gray-300'}`}
            >
              <div className="flex items-center gap-3">
                <div className={`p-2 rounded-full flex items-center justify-center w-8 h-8 transition-colors ${isChecked ? 'bg-black text-white' : 'bg-gray-100 text-gray-400'}`}>
                  <i className={`fa ${isChecked ? 'fa-check text-xs' : 'fa-shield text-xs'}`}></i>
                </div>
                <span className="text-[13px] font-medium text-gray-700">Confirm details are correct</span>
              </div>
              <input 
                type="checkbox" 
                checked={isChecked}
                onChange={() => {}} 
                className="w-5 h-5 accent-black rounded-md cursor-pointer"
              />
            </div>

            {/* Pay Now Button */}
            {/* <button 
              type="button"
              onClick={handleSubmit}
              className="w-full group relative flex items-center justify-center gap-3 bg-black text-white py-4 md:py-5 rounded-2xl font-bold text-lg hover:bg-gray-800 transition-all active:scale-[0.98] shadow-xl disabled:opacity-30 disabled:cursor-not-allowed"
             disabled={!isChecked || !amount || !signature}
            >
              <span>Pay ₹{amount || '0'} Now</span>
              <i className="fa fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
            </button> */}




            <button 
  type="button"
  onClick={handleSubmit}
  disabled={!isChecked || !amount || !signature || !location || loading}
  className="w-full flex items-center justify-center gap-3 bg-black text-white py-4 rounded-2xl font-bold text-lg disabled:opacity-40"
>
  {loading ? (
    <div className="flex items-center gap-3">
      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
      Processing...
    </div>
  ) : (
    <>
      Pay ₹{amount || '0'} Now
    </>
  )}
</button>



          </form>
        </div>
      </div>
    </div>
  );
}